import React, { Component } from 'react';
import * as styled from './lottie.styled';
import lottie from 'lottie-web';

class Lottie extends Component {

    constructor() {
        super();
        this.element = React.createRef();
        this.lottie = null;
    }

    componentDidCatch(){}

    componentDidMount() {
        this.lottie = lottie.loadAnimation({
            container: this.element.current,
            loop: false,
            renderer: null,
            autoplay: false,
            animationData: this.props.animation
        });
        this.lottie.addEventListener("complete", () => {
            if (this.props.onComplete) this.props.onComplete();
        });
    }

    play() { this.lottie.play(); }

    setDirection(direction) { this.lottie.setDirection(direction); }

    goToAndStop(value, isFrame) { this.lottie.goToAndStop(value, isFrame); }

    render() {
        return (
            <styled.Lottie ref={this.element}></styled.Lottie>
        );
    }
}

export default Lottie;